<template>
  <div>
    <TopBar :page="topBarData" @addBtnClick="addBtnClicked"/>

    <v-container fluid>

      <v-row>
        <v-col>
          <CreditControlStatuses />
        </v-col>
      </v-row>

      <v-row>
        <v-col>
          <CreditControlTable />
        </v-col>
      </v-row>

    </v-container>

    <CreditControlFilterDialog v-model="creditControlFilterOpen" />
  </div>
</template>

<script>
  import TopBar from '@/components/Layout/TopBar';
  import CreditControlStatuses from '@/components/CreditControl/CreditControlDashboard/CreditControlStatuses';
  import CreditControlTable from '@/components/CreditControl/CreditControlDashboard/CreditControlTable';
  import CreditControlFilterDialog from '@/components/CreditControl/CreditControlDashboard/CreditControlFilterDialog';

  export default {
    components: { TopBar, CreditControlStatuses, CreditControlTable, CreditControlFilterDialog },

    data() {
      return {
        topBarData: {
          name: 'Credit Control',
          type: '',
          showSearch: true,
          menu: false,
          breadcrumbs: [],
          additionalButtons: [
            {
              inner: 'filter',
              color: 'secondary',
              method: 'openCreditControlFilterDialog',
            }
          ],
          showBeehiveIcon: false,
        },
        creditControlFilterOpen: false
      }
    },
    
    methods: {
      addBtnClicked(btnName){
        switch(btnName){
          case 'openCreditControlFilterDialog':
            this.creditControlFilterOpen = true;
            break;
        }
      },
    }  
  }
</script>

<style lang="scss" scoped>
</style>